import { render, staticRenderFns } from "./index.vue?vue&type=template&id=404b6d76&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=404b6d76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b6d76",
  null
  
)

export default component.exports